import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FlightStep } from '../../flight.types';
import { FlightOption } from './FlightOption';

type FlightMultipleOptionsProps = {
  flightsToChooseBetween: FlightStep[];
  onSelect: (flight: FlightStep) => void;
};

export const FlightMultipleOptions: FC<FlightMultipleOptionsProps> = (props) => {
  const { flightsToChooseBetween, onSelect } = props;
  const { t } = useTranslation();
  return (
    <div className="flights-to-choose-between">
      <div className="text">{t('flight.multiple-flights-found')}</div>
      <div className="flights-to-choose-between__list">
        {flightsToChooseBetween.map((f: FlightStep) => (
          <FlightOption key={f._id} flight={f} onSelect={() => onSelect(f)} />
        ))}
      </div>
    </div>
  );
};
